"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdfElementDescriptionSchema = exports.PdfElementSchema = exports.PdfTableFormatSchema = exports.PdfTableFormat = exports.PdfElementTypeSchema = exports.PdfElementType = void 0;
const zod_1 = require("zod");
const BoundingBox_1 = require("../Common/BoundingBox");
var PdfElementType;
(function (PdfElementType) {
    PdfElementType["List"] = "list";
    PdfElementType["Table"] = "table";
    PdfElementType["Text"] = "text";
    PdfElementType["Title"] = "title";
    PdfElementType["Figure"] = "figure";
})(PdfElementType || (exports.PdfElementType = PdfElementType = {}));
exports.PdfElementTypeSchema = zod_1.z.nativeEnum(PdfElementType);
var PdfTableFormat;
(function (PdfTableFormat) {
    PdfTableFormat["Json"] = "json";
    PdfTableFormat["Markdown"] = "markdown";
})(PdfTableFormat || (exports.PdfTableFormat = PdfTableFormat = {}));
exports.PdfTableFormatSchema = zod_1.z.nativeEnum(PdfTableFormat);
exports.PdfElementSchema = zod_1.z.object({
    type: exports.PdfElementTypeSchema,
    pageNumber: zod_1.z.number(),
    text: zod_1.z.string().optional(),
    base64CropImage: zod_1.z.string().optional(),
    boundingBox: BoundingBox_1.boundingBoxSchema.optional(),
});
exports.PdfElementDescriptionSchema = zod_1.z.object({
    shortDescription: zod_1.z
        .string()
        .describe('A single sentence (maximum two sentences) summary of what the element depicts'),
    longDescription: zod_1.z
        .string()
        .describe('A detailed description focusing on what the element depicts, its key elements, and any relevant technical details'),
});
//# sourceMappingURL=PdfElement.js.map